import '@stimulus/polyfills'
import { Application, Controller } from 'stimulus'

import './component.scss'

const app = Application.start()

const OPENING_HOUR = 10
const CLOSING_HOUR = 19

app.register(
  'site-business-hours',
  class extends Controller {
    static targets = ["circle", "statusText"]
    connect () {
      this.updateBusinessHours()
    }

    updateBusinessHours () {
      const currentDate = new Date()
      const currentHour = currentDate.getHours()
      const circle = this.circleTarget
      const statusText = this.statusTextTarget
      if (currentHour >= OPENING_HOUR && currentHour < CLOSING_HOUR) {
        circle.classList.remove('closing')
        statusText.classList.remove('closed')

        circle.classList.add('blinking')
        statusText.classList.add('opened')
        statusText.textContent = '現在営業中'
      } else {
        circle.classList.remove('blinking')
        statusText.classList.remove('opened')

        circle.classList.add('closing')
        statusText.classList.add('closed')
        statusText.textContent = '営業時間外'
      }
    }
  }
)
